import React, { useState, useEffect } from 'react'
import styled from 'styled-components' 
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const MobileHeaderView = styled.div`
  display: flex;
  position: fixed;
  padding: 0 2rem 0 0;
  top: 0;
  left: 0;
  right: 0;
  height: 49px;
  align-items: center;
  z-index: 500;

  @media screen and (min-width: 768px) {
    display: none;
  }
`

const MenuItem = styled.span`
  font-size: 12px;
  font-family: 'Sica', sans-serif;
  color: ${({isActive}) => isActive ? '#000': ' #fff'};
  margin-left: auto;
  display: inline-block;
`

gsap.registerPlugin(ScrollTrigger)

const MobileHeader = ({
  toggleMobileMenu,
  isOpen,
  closeSavedEventsMenu,
  isSavedEventsMenuOpen
}) => {

  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    ScrollTrigger.create({
      trigger: 'body',
      start: '40px',
      end: '80px',
      onLeaveBack: () => gsap.to('.mobile-header', {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        onComplete: setIsActive(false)
      }),
      onEnter: () => {
        gsap.to('.mobile-header', {
          backgroundColor: 'rgba(255, 255, 255, 1)',
          onComplete: setIsActive(true)
        })
      },
    })
  }, [isActive])

  return (
    <MobileHeaderView className='mobile-header' isActive={isActive && !isOpen} >
      {isSavedEventsMenuOpen && <MenuItem onClick={closeSavedEventsMenu} isActive={isActive}>Close Saved Menu</MenuItem>}
      <MenuItem onClick={toggleMobileMenu} isActive={isActive}>{isOpen ? 'Close' : 'Menu'}</MenuItem>
    </MobileHeaderView>
  )
}

export default MobileHeader
